module.exports = __webpack_public_path__ + "public/images/painting.dfbd9b8ff22d45702fcf6b52a769a568.png";